import { Link } from "@mui/material";
import { DSValueTypography } from "./system-design/Typography";

const Terms = () => {
  return (
    <DSValueTypography sx={{ whiteSpace: "pre-wrap" }}>
      <strong>TERMS OF USE</strong>
      {"\n"}
      Last Modified: January 12, 2024
      {"\n\n"}
      <strong>Acceptance of the Terms of Use</strong>
      {"\n"}
      These terms of use are entered into by and between You and KLYDOCLOCK
      LLC., a Delaware Limited Liability Company ("Company," "we," or "us"). The
      following terms and conditions, together with any documents they expressly
      incorporate by reference (collectively, "Terms of Use"), govern your
      access to and use of{" "}
      <Link
        href="https://www.KlydoClock.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.KlydoClock.com/
      </Link>
      , including any content, functionality, and services offered on or through{" "}
      <Link
        href="https://www.KlydoClock.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.KlydoClock.com/
      </Link>{" "}
      (the "Website"), whether as a guest or a registered user.
      {"\n\n"}
      Please read the Terms of Use carefully before you start to use the
      Website. By using the Website, you accept and agree to be bound and abide
      by these Terms of Use and our Privacy Policy, found at{" "}
      <Link
        href="https://www.klydoclock.com/pages/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.klydoclock.com/pages/privacy-policy
      </Link>{" "}
      incorporated herein by reference. If you do not want to agree to these
      Terms of Use or the Privacy Policy, you must not access or use the
      Website.
      {"\n\n"}
      This Website is offered and available to users who are 18 years of age or
      older. By using this Website, you represent and warrant that you are of
      legal age to form a binding contract with the Company and meet all of the
      foregoing eligibility requirements. If you do not meet all of these
      requirements, you must not access or use the Website.
      {"\n\n"}
      <strong>Changes to the Terms of Use</strong>
      {"\n"}
      We may revise and update these Terms of Use from time to time in our sole
      discretion. All changes are effective immediately when we post them, and
      apply to all access to and use of the Website thereafter. However, any
      changes to the dispute resolution provisions set out in Governing Law and
      Jurisdiction (below) will not apply to any disputes for which the parties
      have actual notice on or before the date the change is posted on the
      Website.
      {"\n\n"}
      Your continued use of the Website following the posting of revised Terms
      of Use means that you accept and agree to the changes. You are expected to
      check this page frequently so you are aware of any changes, as they are
      binding on you.
      {"\n\n"}
      <strong>Accessing the Website and Account Security</strong>
      {"\n"}
      We reserve the right to withdraw or amend this Website, and any service or
      material we provide on the Website, in our sole discretion without notice.
      We will not be liable if for any reason all or any part of the Website is
      unavailable at any time or for any period. From time to time, we may
      restrict access to some parts of the Website, or the entire Website, to
      users, including registered users.
      {"\n\n"}
      You are responsible for both:
      {"\n"}• Making all arrangements necessary for you to have access to the
      Website.
      {"\n"}• Ensuring that all persons who access the Website through your
      internet connection are aware of these Terms of Use and comply with them.
      {"\n\n"}
      To access the Website or some of the resources it offers, you may be asked
      to provide certain registration details or other information. It is a
      condition of your use of the Website that all the information you provide
      on the Website is correct, current, and complete. You agree that all
      information you provide to register with this Website or otherwise,
      including, but not limited to, through the use of any interactive features
      on the Website, is governed by our Privacy Policy, and you consent to all
      actions we take with respect to your information consistent with our
      Privacy Policy.
      {"\n\n"}
      If you choose, or are provided with, a user name, password, or any other
      piece of information as part of our security procedures, you must treat
      such information as confidential, and you must not disclose it to any
      other person or entity. You also acknowledge that your account is personal
      to you and agree not to provide any other person with access to this
      Website or portions of it using your user name, password, or other
      security information. You agree to notify us immediately of any
      unauthorized access to or use of your user name or password or any other
      breach of security. You also agree to ensure that you exit from your
      account at the end of each session. You should use particular caution when
      accessing your account from a public or shared computer so that others are
      not able to view or record your password or other personal information.
      {"\n\n"}
      We have the right to disable any user name, password, or other identifier,
      whether chosen by you or provided by us, at any time in our sole
      discretion for any or no reason, including if, in our opinion, you have
      violated any provision of these Terms of Use.
      {"\n\n"}
      We may provide you with the option to purchase a KlydoClock (the
      "Product") through the Website, under the terms and in consideration for a
      price we determine and present on the Website from time to time in our
      sole and absolute discretion.
      {"\n\n"}
      If you purchase a Product through the Website, you will be required to
      provide your billing and shipping information and to pay the Product fees
      charged by the Company, using means made available by the Company from
      time to time, in its sole and absolute discretion. Such payment means may
      include, without limitation, bank wire transfers and credit cards (each, a
      "Payment Means") so that we may charge you for the costs and fees
      associated with your purchase. You represent and warrant that you are the
      authorized account holder on all Payment Means you submit through the
      Website, and acknowledge and agree that we have the right to charge your
      Payment Means for the cost of the Products, and all taxes, shipping, and
      handling fees communicated to you at the time of your purchase.
      {"\n\n"}
      Your order is an offer to us to buy the Product(s) in specifically
      mentioned your order. When you place an order to purchase a Product, we
      will send you an email confirming receipt of your order and containing the
      details of your order (the "Order Confirmation Email"). The Order
      Confirmation Email is acknowledgement that we have received your order,
      and does not confirm acceptance of your offer to buy the Product(s)
      ordered. We only accept your offer, and conclude the contract of sale for
      a Product ordered by you, when we dispatch the Product to you and send
      email confirmation to you that we've dispatched the Product to you.
      {"\n\n"}
      All Payment Means are provided by Third-Party Providers, and any
      disclaimer provided in these Terms with respect to such Third-Party
      Providers, applies when you use the Payment Means. If the institution
      operating any Payment Means refuses to make payment to us, we are not
      liable for delays or for failure to deliver any Products.
      {"\n\n"}
      <strong>Third-Party Infrastructure and Service Providers</strong>
      {"\n"}
      You understand and acknowledge that the Company uses third-party
      infrastructure, such as servers, security protocols, website management
      platforms, databases, money clearance services and other third-party
      service providers, to make the Website available, to market, promote and
      sell the Products, and to charge fees for purchase thereof (collectively
      referred to herein as "Third-Party Providers"). You acknowledge and agree
      (without limiting or derogating from our disclaimers herein) that the
      availability, functionality and your access to the Website and the
      purchase of the Products, is subject, inter alia, to such Third-Party
      Providers' services' availability. A partial list of currently used
      Third-Party Providers includes: [*]. This list may be amended from time to
      time.
      {"\n\n"}
      <strong>Klydo Greet</strong>
      {"\n"}
      Using the Website, we may allow users of the Website to send greets and
      other content (collectively, the "User Contributions") to users of the
      Product, whether in the course of the Product purchase (for example if you
      purchase a Product for others) or otherwise, as we allow and permit from
      time to time, in our sole and absolute discretion (such functionality, the
      "Klydo Greet").
      {"\n\n"}
      When using the Klydo Greet functionality, you undertake to adhere to our
      AUP (as defined below) and to meet our Content Standards outlined below.
      {"\n\n"}
      Any User Contribution you upload to the Website will be considered
      non-confidential and non-proprietary. By providing or posting any User
      Contribution on the Website, you grant us and our affiliates and service
      providers, and each of their and our respective licensees, successors, and
      assigns an irrevocable, perpetual, worldwide, assignable (through multiple
      tiers), transferable license and a right to use, reproduce, modify,
      perform, display, distribute, and otherwise disclose to third parties any
      such material for any purpose.
      {"\n\n"}
      You understand and agree that errors may occur and it is possible that
      other users of the Product and Website (i.e. except for the user of the
      Product you intended to deliver the User Contributions to) may be exposed
      to your User Contributions. We do not represent that your User
      Contributions will become available or will be viewed solely by your
      intended targeted user, and errors of delivery of your User Contributions
      to others users of Products or this Website may occur. We assume no
      liability for such errors.
      {"\n\n"}
      You represent and warrant that:
      {"\n"}• You own or control all rights in and to the User Contributions and
      have the right to grant the license granted above to us and our affiliates
      and service providers, and each of their and our respective licensees,
      successors, and assigns.
      {"\n"}• All of your User Contributions do and will comply with these Terms
      of Use and any applicable law.
      {"\n\n"}
      You understand and acknowledge that you are responsible for any User
      Contributions you submit or contribute, and you, not the Company, have
      full responsibility for such content, including, without limitation, its
      legality, reliability, accuracy, and appropriateness.
      {"\n\n"}
      We are not responsible or liable to you or to any third party for the
      content or accuracy of any User Contributions posted by you or any other
      user of the Website.
      {"\n\n"}
      <strong>Content Standards</strong>
      {"\n"}
      These content standards apply to any and all User Contributions. User
      Contributions must in their entirety comply with all applicable federal,
      state, local, and international laws and regulations. Without limiting the
      foregoing, User Contributions must not:
      {"\n"}• Contain any material that is defamatory, obscene, indecent,
      abusive, offensive, harassing, violent, hateful, inflammatory, or
      otherwise objectionable.
      {"\n"}• Promote sexually explicit or pornographic material, violence, or
      discrimination based on race, sex, religion, nationality, disability,
      sexual orientation, or age.
      {"\n"}• Infringe any patent, trademark, trade secret, copyright, or other
      intellectual property or other rights of any other person.
      {"\n"}• Violate the legal rights (including the rights of publicity and
      privacy) of others or contain any material that could give rise to any
      civil or criminal liability under applicable laws or regulations or that
      otherwise may be in conflict with these Terms of Use or our Privacy
      Policy.
      {"\n"}• Be likely to deceive any person.
      {"\n"}• Promote any illegal activity, or advocate, promote, or assist any
      unlawful act.
      {"\n"}• Cause annoyance, inconvenience, or needless anxiety or be likely
      to upset, embarrass, alarm, or annoy any other person.
      {"\n"}• Impersonate any person, or misrepresent your identity or
      affiliation with any person or organization.
      {"\n"}• Involve commercial activities or sales, such as contests,
      sweepstakes, and other sales promotions, barter, or advertising.
      {"\n"}• Give the impression that they emanate from or are endorsed by us
      or any other person or entity, if this is not the case.
      {"\n\n"}
      <strong>Klydo Collections</strong>
      {"\n"}
      Using the Website, we may allow users of the Website to subscribe to one
      or several media-art items we refer to as "Collections," and to present
      such Collections on a Product by submitting a Collection ID (as such term
      is defined below). The Company hereby grants each user of the Product who
      purchased a Collection or for which a Collection was purchased, a limited,
      non-exclusive, non-sub-licensable, non-transferable (except as described
      at the end of the next paragraph) to present the Collection on such
      Product. Except for the explicit rights provided under that license (as
      described above), the user has no additional rights in or to the
      Collection.
      {"\n\n"}
      When a user of the Website subscribes to a Collection, the user receives a
      unique Collection identification code (the "Collection ID") via email, to
      an email address submitted by the user. Please follow the instructions
      provided in such email in order to install a Collection on the designated
      Product. Once a Collection ID has been submitted using a Product, it can
      only be installed on that specific Product. However, you may uninstall one
      or several Collection ID(s) from your Product and install it on another
      Product. In that sense the license granted to a specific Collection is
      transferable.
      {"\n\n"}
      It is the user's sole responsibility to make sure the email address and
      any other information requested to be submitted in the process of
      subscribing a Collection is true and accurate.
      {"\n\n"}
      Collections are provided by third parties, and the Company provides no
      representation or warranty with respect to the content or data presented
      in each such Collection, including any representation or warranty with
      respect to the Collections not breaching third party rights, or being fit
      for any purpose or appropriate for any age. However, if you have found and
      reported in accordance with the terms of these Terms of Use that a
      Collection breaches any third party rights, the Company may, if it
      believes such rights were indeed breached, cancel your subscription to the
      relevant breaching Collection and provide a refund for your subscription.
      Except in the foregoing circumstances, a subscription to Collection is
      non-refundable.
      {"\n\n"}A Product can store a limited number of Collections. A user of a
      Product can remove existing Collections installed on the Product, in order
      to add additional Collections. Removed Collections may be added back using
      the original Collection ID provided to the user, as set forth above.
      {"\n\n"}
      <strong>Intellectual Property Rights</strong>
      {"\n"}
      The Website and its entire contents, features, and functionality
      (including but not limited to all information, software, text, displays,
      images, video, and audio, and the design, selection, and arrangement
      thereof) are owned by the Company, its licensors, or other providers of
      such material and are protected by the United States and international
      copyright, trademark, patent, trade secret, and other intellectual
      property or proprietary rights laws.
      {"\n\n"}
      These Terms of Use permit you to use the Website for your personal,
      non-commercial use only. You must not reproduce, distribute, modify,
      create derivative works of, publicly display, publicly perform, republish,
      download, store, or transmit any of the material on our Website, except as
      follows:
      {"\n"}• Your computer may temporarily store copies of such materials in
      RAM incidental to your accessing and viewing those materials.
      {"\n"}• You may store files that are automatically cached by your Web
      browser for display enhancement purposes.
      {"\n"}• You may print one copy of a reasonable number of pages of the
      Website for your own personal, non-commercial use and not for further
      reproduction, publication, or distribution.
      {"\n"}• If we provide social media features with certain content, you may
      take such actions as are enabled by such features.
      {"\n\n"}
      You must not:
      {"\n"}• Modify copies of any materials from this site.
      {"\n"}• Use any illustrations, photographs, video or audio sequences, or
      any graphics separately from the accompanying text.
      {"\n"}• Delete or alter any copyright, trademark, or other proprietary
      rights notices from copies of materials from this site.
      {"\n\n"}
      You must not access or use for any commercial purposes any part of the
      Website or any services or materials available through the Website.
      {"\n\n"}
      If you wish to make any use of material on the Website other than that set
      out in this section, please address your request to:{" "}
      <Link href="mailto:contact@klydoclock.com">contact@klydoclock.com</Link>.
      {"\n\n"}
      If you print, copy, modify, download, or otherwise use or provide any
      other person with access to any part of the Website in breach of the Terms
      of Use, your right to use the Website will stop immediately and you must,
      at our option, return or destroy any copies of the materials you have
      made. No right, title, or interest in or to the Website or any content on
      the Website is transferred to you, and all rights not expressly granted
      are reserved by the Company. Any use of the Website not expressly
      permitted by these Terms of Use is a breach of these Terms of Use and may
      violate copyright, trademark, and other laws.
      {"\n\n"}
      <strong>Trademarks</strong>
      {"\n"}
      The Company's name, the terms "KlydoClock", the Company's logo, and all
      related names, logos, product and service names, designs, and slogans are
      trademarks of the Company or its affiliates or licensors. You must not use
      such marks without the prior written permission of the Company. All other
      names, logos, product and service names, designs, and slogans on this
      Website are the trademarks of their respective owners.
      {"\n\n"}
      <strong>Acceptable Use Policy</strong>
      {"\n"}
      The Website may not be used for unlawful, fraudulent, offensive, or
      obscene activity, as further described and set forth in Our acceptable use
      policy ("AUP") located at{" "}
      <Link
        href="https://www.klydoclock.com/pages/acceptable-use-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.klydoclock.com/pages/acceptable-use-policy
      </Link>
      , as may be amended from time to time, which is incorporated herein by
      reference. You will comply with all terms and conditions of this
      Agreement, all applicable laws, rules, and regulations, and all
      guidelines, standards, and requirements that may be posted on this Website
      from time to time, including the AUP.
      {"\n\n"}
      <strong>Monitoring and Enforcement; Termination</strong>
      {"\n"}
      We have the right to:
      {"\n"}• Remove any User Contributions for any or no reason in our sole
      discretion.
      {"\n"}• Disclose your identity or other information about you to any third
      party who claims that material posted by you violates their rights,
      including their intellectual property rights or their right to privacy.
      {"\n"}• Take appropriate legal action, including without limitation,
      referral to law enforcement, for any illegal or unauthorized use of the
      Website.
      {"\n"}• Terminate or suspend your access to all or part of the Website for
      any or no reason, including without limitation, any violation of these
      Terms of Use.
      {"\n\n"}
      Without limiting the foregoing, we have the right to cooperate fully with
      any law enforcement authorities or court order requesting or directing us
      to disclose the identity or other information of anyone posting any
      materials on or through the Website. YOU WAIVE AND HOLD HARMLESS THE
      COMPANY AND ITS AFFILIATES, LICENSEES, AND SERVICE PROVIDERS FROM ANY
      CLAIMS RESULTING FROM ANY ACTION TAKEN BY THE COMPANY AND ANY OF THE
      FOREGOING PARTIES DURING, OR TAKEN AS A CONSEQUENCE OF, INVESTIGATIONS BY
      EITHER THE COMPANY AND SUCH PARTIES OR LAW ENFORCEMENT AUTHORITIES.
      {"\n\n"}
      However, we cannot and do not undertake to review all material before it
      is posted on the Website, and cannot ensure prompt removal of
      objectionable material after it has been posted. Accordingly, we assume no
      liability for any action or inaction regarding transmissions,
      communications, or content provided by any user or third party. We have no
      liability or responsibility to anyone for performance or nonperformance of
      the activities described in this section.
      {"\n\n"}
      <strong>Copyright Infringement</strong>
      {"\n"}
      If you believe that any material that appears in the Website or any User
      Contribution violate your copyright, please see our{" "}
      <Link
        href="https://www.klydoclock.com/pages/copyright-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Copyright Policy
      </Link>{" "}
      for instructions on sending us a notice of copyright infringement. It is
      the policy of the Company to terminate the user accounts of repeat
      infringers.
      {"\n\n"}
      <strong>Reliance on Information Posted</strong>
      {"\n"}
      The information presented on or through the Website is made available
      solely for general information purposes. We do not warrant the accuracy,
      completeness, or usefulness of this information. Any reliance you place on
      such information is strictly at your own risk. We disclaim all liability
      and responsibility arising from any reliance placed on such materials by
      you or any other visitor to the Website, or by anyone who may be informed
      of any of its contents.
      {"\n\n"}
      This Website may include content provided by third parties, including
      materials provided by other users, bloggers, and third-party licensors,
      syndicators, aggregators, and/or reporting services. All statements and/or
      opinions expressed in these materials, and all articles and responses to
      questions and other content, other than the content provided by the
      Company, are solely the opinions and the responsibility of the person or
      entity providing those materials. These materials do not necessarily
      reflect the opinion of the Company. We are not responsible, or liable to
      you or any third party, for the content or accuracy of any materials
      provided by any third parties.
      {"\n\n"}
      <strong>Changes to the Website</strong>
      {"\n"}
      We may update the content on this Website from time to time, but its
      content is not necessarily complete or up-to-date. Any of the material on
      the Website may be out of date at any given time, and we are under no
      obligation to update such material.
      {"\n\n"}
      <strong>Information About You and Your Visits to the Website</strong>
      {"\n"}
      All information we collect on this Website is subject to our Privacy
      Policy. By using the Website, you consent to all actions taken by us with
      respect to your information in compliance with the Privacy Policy.
      {"\n\n"}
      <strong>Linking to the Website and Social Media Features</strong>
      {"\n"}
      You may link to our homepage, provided you do so in a way that is fair and
      legal and does not damage our reputation or take advantage of it, but you
      must not establish a link in such a way as to suggest any form of
      association, approval, or endorsement on our part without our express
      written consent.
      {"\n\n"}
      This Website may provide certain social media features that enable you to:
      {"\n"}• Link from your own or certain third-party websites to certain
      content on this Website.
      {"\n"}• Send emails or other communications with certain content, or links
      to certain content, on this Website.
      {"\n"}• Cause limited portions of content on this Website to be displayed
      or appear to be displayed on your own or certain third-party websites.
      {"\n\n"}
      You may use these features solely as they are provided by us, and solely
      with respect to the content they are displayed with, and otherwise in
      accordance with any additional terms and conditions we provide with
      respect to such features. Subject to the foregoing, you must not:
      {"\n"}• Establish a link from any website that is not owned by you.
      {"\n"}• Cause the Website or portions of it to be displayed on, or appear
      to be displayed by, any other site, for example, framing, deep linking, or
      in-line linking.
      {"\n"}• Link to any part of the Website other than the homepage.
      {"\n"}• Otherwise take any action with respect to the materials on this
      Website that is inconsistent with any other provision of these Terms of
      Use.
      {"\n\n"}
      The website from which you are linking, or on which you make certain
      content accessible, must comply in all respects with the Content Standards
      set out in these Terms of Use.
      {"\n\n"}
      You agree to cooperate with us in causing any unauthorized framing or
      linking immediately to stop. We reserve the right to withdraw linking
      permission without notice.
      {"\n\n"}
      We may disable all or any social media features and any links at any time
      without notice in our discretion.
      {"\n\n"}
      <strong>Social Features</strong>
      {"\n"}
      We may, from time to time, allow purchasers of the Product to include
      specific and dedicated greetings and materials (such as photos, videos,
      etc.) together with Products purchased as gifts to third parties (such
      greetings and materials, the "Personalized Content").
      {"\n\n"}
      The Personalized Content must comply with these Terms of Use and our AUP
      (Acceptable Use Policy). We are not responsible for any third party
      content or materials included in the Personalized Content, and any claim
      and/or demand with respect to the Personalized Content shall be addressed
      solely by the sender of such Personalized Content.
      {"\n\n"}
      <strong>Links from the Website</strong>
      {"\n"}
      If the Website contains links to other sites and resources provided by
      third parties, these links are provided for your convenience only. This
      includes links contained in advertisements, including banner
      advertisements and sponsored links. We have no control over the contents
      of those sites or resources, and accept no responsibility for them or for
      any loss or damage that may arise from your use of them. If you decide to
      access any of the third-party websites linked to this Website, you do so
      entirely at your own risk and subject to the terms and conditions of use
      for such websites.
      {"\n\n"}
      <strong>Geographic Restrictions</strong>
      {"\n"}
      The owner of the Website is based in the State of Delaware. We make no
      claims that the Website or any of its content is accessible or appropriate
      outside of the State of Delaware. Access to the Website may not be legal
      by certain persons or in certain countries. If you access the Website from
      outside the State of Delaware, you do so on your own initiative and are
      responsible for compliance with local laws.
      {"\n\n"}
      <strong>Disclaimer of Warranties</strong>
      {"\n"}
      You understand that we cannot and do not guarantee or warrant that files
      available for downloading from the internet or the Website will be free of
      viruses or other destructive code. You are responsible for implementing
      sufficient procedures and checkpoints to satisfy your particular
      requirements for anti-virus protection and accuracy of data input and
      output, and for maintaining a means external to our site for any
      reconstruction of any lost data. TO THE FULLEST EXTENT PROVIDED BY LAW, WE
      WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A DISTRIBUTED
      DENIAL-OF-SERVICE ATTACK, VIRUSES, OR OTHER TECHNOLOGICALLY HARMFUL
      MATERIAL THAT MAY INFECT YOUR COMPUTER EQUIPMENT, COMPUTER PROGRAMS, DATA,
      OR OTHER PROPRIETARY MATERIAL DUE TO YOUR USE OF THE WEBSITE OR ANY
      SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE OR TO YOUR DOWNLOADING OF
      ANY MATERIAL POSTED ON IT, OR ON ANY WEBSITE LINKED TO IT.
      {"\n\n"}
      YOUR USE OF THE WEBSITE, ITS CONTENT, AND ANY SERVICES OR ITEMS OBTAINED
      THROUGH THE WEBSITE IS AT YOUR OWN RISK. THE WEBSITE, ITS CONTENT, AND ANY
      SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE ARE PROVIDED ON AN "AS IS"
      AND "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER
      EXPRESS OR IMPLIED. NEITHER THE COMPANY NOR ANY PERSON ASSOCIATED WITH THE
      COMPANY MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE
      COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY, OR AVAILABILITY OF
      THE WEBSITE. WITHOUT LIMITING THE FOREGOING, NEITHER THE COMPANY NOR
      ANYONE ASSOCIATED WITH THE COMPANY REPRESENTS OR WARRANTS THAT THE
      WEBSITE, ITS CONTENT, OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE
      WEBSITE WILL BE ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED, THAT
      DEFECTS WILL BE CORRECTED, THAT OUR SITE OR THE SERVER THAT MAKES IT
      AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, OR THAT THE
      WEBSITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE WILL
      OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.
      {"\n\n"}
      TO THE FULLEST EXTENT PROVIDED BY LAW, THE COMPANY HEREBY DISCLAIMS ALL
      WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY, OR
      OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY,
      NON-INFRINGEMENT, AND FITNESS FOR PARTICULAR PURPOSE.
      {"\n\n"}
      WITHOUT DEROGATING FROM ANY OF THE AFORESAID, YOU ACKNOWLEDGE AND AGREE
      THAT THE COMPANY IS NOT AND SHALL NOT BE RESPONSIBLE FOR THE AVAILABILITY
      OF THE THIRD-PARTY PROVIDERS' INFRASTRUCTURE OR SERVICES, NOR SHALL THE
      COMPANY BE RESPONSIBLE OR LIABLE FOR ANY DAMAGE CAUSED TO YOU DUE TO ANY
      ACT OR OMISSION ON BEHALF OF SUCH THIRD-PARTY PROVIDERS OR YOUR USE OF
      THEIR SERVICES.
      {"\n\n"}
      THE FOREGOING DOES NOT AFFECT ANY WARRANTIES THAT CANNOT BE EXCLUDED OR
      LIMITED UNDER APPLICABLE LAW.
      {"\n\n"}
      <strong>Limitation on Liability</strong>
      {"\n"}
      TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL THE COMPANY, ITS
      AFFILIATES, OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS,
      OFFICERS, OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL
      THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR INABILITY TO
      USE, THE WEBSITE, ANY WEBSITES LINKED TO IT, ANY CONTENT ON THE WEBSITE OR
      SUCH OTHER WEBSITES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL,
      CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL
      INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF
      PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF
      GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE),
      BREACH OF CONTRACT, OR OTHERWISE, EVEN IF FORESEEABLE.
      {"\n\n"}
      THE FOREGOING DOES NOT AFFECT ANY LIABILITY THAT CANNOT BE EXCLUDED OR
      LIMITED UNDER APPLICABLE LAW.
      {"\n\n"}
      <strong>Indemnification</strong>
      {"\n"}
      You agree to defend, indemnify, and hold harmless the Company, its
      affiliates, licensors, and service providers, and its and their respective
      officers, directors, employees, contractors, agents, licensors, suppliers,
      successors, and assigns from and against any claims, liabilities, damages,
      judgments, awards, losses, costs, expenses, or fees (including reasonable
      attorneys' fees) arising out of or relating to your violation of these
      Terms of Use or your use of the Website, including, but not limited to,
      any use of the Website's content, services, and products other than as
      expressly authorized in these Terms of Use, or your use of any information
      obtained from the Website.
      {"\n\n"}
      <strong>Governing Law and Jurisdiction; Waiver of Jury Trial</strong>
      {"\n"}
      All matters relating to the Website and these Terms of Use, and any
      dispute or claim arising therefrom or related thereto (in each case,
      including non-contractual disputes or claims), shall be governed by and
      construed in accordance with the internal laws of the State of Delaware
      without giving effect to any choice or conflict of law provision or rule.
      {"\n\n"}
      Any legal suit, action, or proceeding arising out of, or related to, these
      Terms of Use or the Website shall be instituted exclusively in the
      competent courts of the State of Delaware, located in Wilmington,
      Delaware, although we retain the right to bring any suit, action, or
      proceeding against you for breach of these Terms of Use in your country of
      residence or any other relevant country. You waive any and all objections
      to the exercise of jurisdiction over you by such courts and to venue in
      such courts.
      {"\n\n"}
      Each party hereto irrevocably and unconditionally waives, to the fullest
      extent permitted by applicable law, any right it may have to a trial by
      jury in any legal action, proceeding, cause of action, or counterclaim
      arising out of or relating to these Terms of Use, including any exhibits,
      schedules, and appendices attached to these Terms of Use, or the
      transactions contemplated hereby. Each Party certifies and acknowledges
      that (a) no representative of the other party has represented, expressly
      or otherwise, that the other party would not seek to enforce the foregoing
      waiver in the event of a legal action, (b) it has considered the
      implications of this waiver, (c) it makes this waiver knowingly and
      voluntarily, and (d) it has decided to enter into these Terms of Use in
      consideration of, among other things, the mutual waivers and
      certifications in this section.
      {"\n\n"}
      <strong>Limitation on Time to File Claims</strong>
      {"\n"}
      ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF OR RELATING TO
      THESE TERMS OF USE OR THE WEBSITE MUST BE COMMENCED WITHIN ONE (1) YEAR
      AFTER THE CAUSE OF ACTION ACCRUES; OTHERWISE, SUCH CAUSE OF ACTION OR
      CLAIM IS PERMANENTLY BARRED.
      {"\n\n"}
      <strong>Waiver and Severability</strong>
      {"\n"}
      No waiver by the Company of any term or condition set out in these Terms
      of Use shall be deemed a further or continuing waiver of such term or
      condition or a waiver of any other term or condition, and any failure of
      the Company to assert a right or provision under these Terms of Use shall
      not constitute a waiver of such right or provision.
      {"\n\n"}
      If any provision of these Terms of Use is held by a court or other
      tribunal of competent jurisdiction to be invalid, illegal, or
      unenforceable for any reason, such provision shall be eliminated or
      limited to the minimum extent such that the remaining provisions of the
      Terms of Use will continue in full force and effect.
      {"\n\n"}
      <strong>Entire Agreement</strong>
      {"\n"}
      These Terms of Use and our Privacy Policy constitute the sole and entire
      agreement between you and KLYDOCLOCK LLC., a Delaware Limited Liability
      Company regarding the Website and supersede all prior and contemporaneous
      understandings, agreements, representations, and warranties, both written
      and oral, regarding the Website.
      {"\n\n"}
      <strong>Your Comments and Concerns</strong>
      {"\n"}
      This website is operated by KLYDOCLOCK LLC., a Delaware Limited Liability
      Company.
      {"\n\n"}
      All notices of copyright infringement claims should be sent to the
      copyright agent designated in our{" "}
      <Link
        href="https://www.klydoclock.com/pages/copyright-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Website Copyright (DMCA) Policy
      </Link>{" "}
      in the manner and by the means set out therein.
      {"\n\n"}
      All other feedback, comments, requests for technical support, and other
      communications relating to the Website should be directed to:{" "}
      <Link href="mailto:contact@klydoclock.com">contact@klydoclock.com</Link>.
    </DSValueTypography>
  );
};

export default Terms;
